import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

// Edifice View is one single shared project (not one-per-buyer like
// CustodialView), so this is a fixed constant rather than per-deployment
// config — see functions/index.js for what lives behind it.
const FUNCTIONS_BASE = "https://us-central1-edifice-view.cloudfunctions.net";

async function post(fn, body) {
  const res = await fetch(`${FUNCTIONS_BASE}/${fn}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || `${fn} failed`);
  return data;
}

// A Facility Admin's own uid doubles as their license id — see
// firestore.rules' licenses/{ownerUid} and functions/index.js's header
// comment for why (one subscription per owner covers their whole
// building portfolio, not one per building).
export function watchLicense(ownerUid, cb) {
  return onSnapshot(doc(db, "licenses", ownerUid), (snap) => cb(snap.exists() ? snap.data() : null));
}

export function startCheckout(ownerUid, referralLeadId) {
  return post("createCheckoutSession", {
    ownerUid,
    referralLeadId,
    successUrl: window.location.origin,
    cancelUrl: window.location.origin,
  });
}

export function openBillingPortal(ownerUid) {
  return post("createPortalSession", { ownerUid, returnUrl: window.location.origin });
}

// Fire-and-forget — called right after a building is added (see
// FacilityAdminDashboard.jsx's addBuilding). The server recomputes the
// real count from Firestore itself rather than trusting anything sent
// here, so this never needs to pass a count.
export function syncBuildingCount(ownerUid) {
  return post("syncBuildingCount", { ownerUid }).catch((err) => {
    console.warn("syncBuildingCount failed (non-fatal):", err);
  });
}
